import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
  NgbModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import { I18nModule, provideConfig } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { CustomUserRegistrationModule } from 'src/app/custom-user-registration/custom-user-registration.module';
import { TermsConditionsModule } from '../terms-conditions/terms-conditions.module';
import { TermsConditionsComponent } from '../terms-conditions/terms-conditions/terms-conditions.component';
import { CheckoutComponent } from './checkout.component';

@NgModule({
  declarations: [CheckoutComponent],
  exports: [CheckoutComponent],

  imports: [
    CommonModule,
    NgbTooltipModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    CustomUserRegistrationModule,
    I18nModule,
    NgbPopoverModule,
    NgbModule,
    TermsConditionsModule,
    SpinnerModule,
  ],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
      cmsComponents: {
        checkoutPage: {
          component: TermsConditionsComponent,
        },
      },
    }),
  ],
})
export class CheckoutModule {}
